import { defineMessages } from 'react-intl';

const messages = defineMessages({
  // True of EVERY path that reaches it. The handler fires for any hard renewal failure —
  // a backend outage, a dropped connection, a revoked Firebase session — and the app signs
  // nobody out on it. "Your session has expired, sign in again" was wrong for the first two
  // and an instruction the user could not follow from where they stood.
  sessionUnrenewable: {
    id: 'auth.sessionUnrenewable',
    defaultMessage:
      'We could not refresh your session. Some data may not load; if this keeps happening, please sign out and sign in again.',
  },
});

export default messages;
